
import { Quest, QuestCategory } from '../../../types';

export const YOUNG_AUTHOR_QUESTS: Quest[] = [
  {
    id: 1400,
    category: QuestCategory.Creator,
    title: 'The Spark of a Story',
    questlineId: 'young-author',
    isQuestlineStart: true,
    description: 'Every great book begins with a single idea. Your quest is to brainstorm a concept for a new story.',
    details: 'In your lined notebook, start an "Author\'s Log". Brainstorm your story: Who is the main character? Where does it take place? What is the main problem they have to solve? This is the birth of a new world.'
  },
  {
    id: 1401,
    category: QuestCategory.Creator,
    title: 'The First Draft',
    questlineId: 'young-author',
    prerequisiteQuestId: 1400,
    description: 'You have your idea. Now it\'s time to get the story out of your head and onto the page.',
    details: 'Find your Author\'s Log. Now, write the first draft of your story. Don\'t worry about making it perfect! The goal is just to write the whole story from beginning to end. You can fix mistakes later.'
  },
  {
    id: 1402,
    category: QuestCategory.SkillBuilder,
    title: 'The Editor\'s Eye',
    questlineId: 'young-author',
    prerequisiteQuestId: 1401,
    description: 'A great writer is also a great editor. It\'s time to polish your first draft.',
    details: 'Read your story out loud to catch any sentences that sound strange. Then, proofread it carefully. Look for spelling mistakes and check that your sentences start with a capital letter and end with a full stop.'
  },
  {
    id: 1403,
    category: QuestCategory.Creator,
    title: 'The Cover Artist',
    questlineId: 'young-author',
    prerequisiteQuestId: 1402,
    description: 'Every great story needs a great cover. Your mission is to design one.',
    details: 'In your unlined notebook, design the front cover for your story. It should include the title, your name as the author, and an exciting picture that hints at the adventure inside.'
  },
  {
    id: 1404,
    category: QuestCategory.TeamUp,
    title: 'The Author Reading',
    questlineId: 'young-author',
    prerequisiteQuestId: 1403,
    description: 'Your story is complete! It\'s time for its world premiere.',
    details: 'You\'ve written, edited, and designed a cover. Now it\'s time to share it. Do an "author reading" for your family, sharing the story you worked so hard to create. Take a bow!'
  }
];
